import axios from 'axios';

const prefix = '/csvimport';

/**
 * Fetches mappings list based on the import type.
 * @param  {string} importType The type of import.
 * @returns {Promise<{ mappings: import('./types/types').ImportMapping[] }>}
 */
export const getImportMappings = async (importType) => {
  const response = await axios.get(`${prefix}/mapping?importType=${importType}`);
  return response.data;
};

/**
 * Updates an import mapping.
 * @param {{ mappingId: string, name: string, updatedName: string }} request
 * @returns {Promise<string>} empty string
 */
export const updateImportMapping = async (request) => {
  const response = await axios.post(`${prefix}/mapping`, request);
  return response.data;
};

/**
 * Deletes an import mapping.
 * @param {string} mappingId
 * @returns {Promise<string>} empty string
 */
export const deleteImportMapping = async (mappingId) => {
  const response = await axios.delete(`${prefix}/mapping/${mappingId}`);
  return response.data;
};

const emptyGuid = '00000000-0000-0000-0000-000000000000';

/**
 * Initializes an import process.
 * @param {import('./types/types').ImportInitRequest} request
 * @returns {Promise<{
 * jobId: string,
 * definition: import('./types/types').InitImportDefinition,
 * columns: string[],
 * preview: import('./types/types').TemplatePreview[]  }>}
 */
export const initializeImport = async (request) => {
  const payload = new FormData();
  payload.append('csvFile', request.csvFile);
  payload.append('mappingId', request.mapping.mappingId ?? emptyGuid);
  payload.append('importType', request.importType);
  payload.append('salesOrderTemplateName', request.mapping.name);

  const response = await axios.post(`${prefix}/init`, payload, {
    headers: {
      ContentType: 'multipart/form-data',
    },
  });
  return response.data;
};

/**
 * Requests a new import process.
 * @param {import('./types/types').StartImportRequest} request
 * @returns {Promise<string>} empty string
 */
export const startImport = async (request) => {
  const response = await axios.post(`${prefix}/import`, request);
  return response.data;
};

/**
 * Fetches import summary based on jobId.
 * @param {string} jobId The job identifier of the import.
 * @returns {Promise<import('./types/types').ImportSummaryData>}}
 */
export const getImportSummary = async (jobId) => {
  const response = await axios.get(`${prefix}/summary/${jobId}`);
  return response.data;
};
